import {useState,useEffect} from 'react'
import {useDispatch} from 'react-redux'

import {useCreator} from './hooks'

import {
	createCalendarEvent,
	setCreator
} from './slice'

import ReadableRepeat from './ReadableRepeat'

import Select from 'react-select'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import InputGroup from 'react-bootstrap/InputGroup'
import Tooltip from 'react-bootstrap/Tooltip'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'

import DatePicker from 'react-datepicker'
import TimePicker from '../TimePicker/TimePicker'

import {useGymTrainers,useClients} from '../users/hooks'
import useCurrentUser from '../../hooks/useCurrentUser'

import {dateToTimeObj,getTimeString,dateToYMD} from '../../util/datetime'

import {nMap,ellipsis} from '../../util/util'

export default function () {
	const dispatch = useDispatch()

	const {show,time,date} = useCreator()

	const onHide = ()=>{
		resetForm()
		dispatch(setCreator({
			show:false,
			date:null,
			time:{start:{},end:{}}
		}))
	}

	const {status:trainersStatus,trainers} = useGymTrainers()
	const {status:clientsStatus,clients} = useClients()

	const trainerOptions = trainers.map(t=>({
		label:t.user_name,
		value:t.user_id_number
	}))

	const clientOptions = clients.map(c=>({
		label:c.user_name,
		value:c.user_id_number
	}))

	const user = useCurrentUser()

	const isTime24Hour = Number(user.is_24_hour_time) === 1

	const [title,setTitle] = useState('')
	const [description,setDescription] = useState('')
	const [trainingType,setTrainingType] = useState('training')
	const [classSize,setClassSize] = useState('')
	const [link,setLink] = useState('')

	//repeat related state
	const [repeat,setRepeat] = useState('none')
	//daily
	const [dailyInterval,setDailyInterval] = useState(1)
	const [customDailyInterval,setCustomDailyInterval] = useState(1)
	//weekly
	const [weekDays,setWeekDays] = useState([])
	const [weeklyInterval,setWeeklyInterval] = useState(1)
	const daysOfTheWeek = ['sun','mon','tue','wed','thu','fri','sat']

	const [signupCancelBuffer,setSignupCancelBuffer] = useState('')
	
	const weekDayDisplayNameMap = {
		sun:'Sunday',
		mon:'Monday',
		tue:'Tuesday',
		wed:'Wednesday',
		thu:'Thursday',
		fri:'Friday',
		sat:'Saturday'
	}

	const [startTime,setStartTime] = useState(time.start)
	const [endTime,setEndTime] = useState(time.end)

	const [startDate,setStartDate] = useState(new Date())
	const [endDate,setEndDate] = useState(new Date())

	useEffect(()=>{
		setStartDate(
			date
			? new Date(`${date}T00:00:00`)
			: new Date()
		)
		setEndDate(
			date
			? new Date(`${date}T00:00:00`)
			: new Date()
		)
	},[date])

	const [noEndDate,setNoEndDate] = useState(false)

	const [createWorkouts,setCreateWorkouts] = useState(true)

	const [deductSessions,setDeductSesions] = useState(true)

	const [selectedTrainers,setSelectedTrainers] = useState([])
	const [selectedClients,setSelectedClients] = useState([])


	const reminderOptions = [48,24,12,6,1]
	const [reminderTime,setReminderTime] = useState('none')
	const [emailReminders,setEmailReminders] = useState(false)
	const [pushReminders,setPushReminders] = useState(false)

	useEffect(()=>{
		setStartTime(time.start)
		setEndTime(time.end)
	},[time])

	const resetForm = ()=>{
		setTitle('')
		setDescription('')
		setTrainingType('training')
		setClassSize('')
		setRepeat('none')
		setStartDate(new Date())
		setEndDate(new Date())
		setNoEndDate(false)

		setLink('')

		setCreateWorkouts(true)

		setDeductSesions(true)

		setSelectedTrainers([])
		setSelectedClients([])

		setStartTime(time.start)
		setEndTime(time.end)


		setReminderTime('none')
		setEmailReminders(false)
		setPushReminders(false)

	}

	const [isSaving,setIsSaving] = useState(false)
	const handleSave = ()=>{
		setIsSaving(true)
		const payload = {
			action:'createCalendarEvent',
			start_date:`${dateToYMD(startDate)} ${getTimeString(startTime,1)}`,
			end_date:`${dateToYMD(endDate)} ${getTimeString(endTime,1)}`,
			recurrence_type:repeat,
			no_end_date:Number(noEndDate),
			signup_cancel_buffer:signupCancelBuffer,
			body:description,
			link,
			title,
			event_type:trainingType,
			trainer_id:user.user_id_number,
			trainer_ids:selectedTrainers.map(({value})=>value),
			client_ids:selectedClients.map(({value})=>value).join(','),
			reminder_time:reminderTime,
			push_notifications:Number(pushReminders),
			email_notifications:Number(emailReminders),
			deduct_sessions:Number(deductSessions),
			group_session_size:classSize,
			consume_session_credit:Number(deductSessions),
			create_workouts:Number(createWorkouts),
			event_status:''
		}
		//handle converting repeat related state into the 
		//day_string parameter expected by the API
		//day - an integer value coresponding to the interval
		//week - comma seperated list like mon,tue,wed
		if ( repeat==='day' ) {
			payload.day_string = (
				dailyInterval==='custom'
				? customDailyInterval
				: dailyInterval
			)
		} 
		else if (repeat === 'week') {
			payload.day_string = weekDays
				.map(d=>daysOfTheWeek.indexOf(d))
				.sort((a,b)=>a-b)
				.join(',')
			payload.week_repeat_freq = weeklyInterval
		}

		dispatch(createCalendarEvent(payload)).then(res=>{
			setIsSaving(false)
			if(res.payload.success==='1'){
				onHide()
				resetForm()
			} else {
				window.alert(ellipsis(res.payload.message,80))
			}
		})
	}

	return (
		<Modal show={show} size="lg" onHide={onHide}>
			<Modal.Header>
				Create Event
			</Modal.Header>
			<Modal.Body>
				<div>
					<div>
						<small>Title</small>
						<Form.Control
							value={title}
							onChange={e=>{
								setTitle(e.target.value)
							}}
						/>
					</div>
					<div>
						<small>Description</small>
						<Form.Control 
							onChange={e=>{
								setDescription(e.target.value)
							}}
							value={description}
							as="textarea"
						/>
					</div>
					<div>
						<small>Link</small>
						<Form.Control
							value={link}
							onChange={e=>{
								setLink(e.target.value)
							}}
						/>
					</div>
				</div>
				<small>Type</small>
				<Form.Control 
					onChange={e=>{
						setTrainingType(e.target.value)
					}}
					value={trainingType}
					as="select" 
					className="mt-2"
				>
					<option value="training">
						Training Session
					</option>
					<option value="semi_private">
						Semi-private training session
					</option>
					<option value="personal">
						Personal/Unavailable
					</option>
					<option value="group_session">
						Class/Group Session
					</option>
					<option value="meeting">
						Meeting
					</option>
					<option value="notes">
						Notes
					</option>
					<option value="closed">
						Closed
					</option>
				</Form.Control>
				{trainingType==='training'&&
					<Form.Check
						onChange={e=>{
							setCreateWorkouts(e.target.checked)
						}}
						checked={createWorkouts}
						id="create-session-workouts-check"
						label={`Add training session as a workout to client calendars`}
					/>
				}
				{trainingType==='semi_private'&&
					<div>
						<small>Training Session Size</small>
						<Form.Control 
							value={classSize}
							onChange={e=>{
								setClassSize(e.target.value)
							}}
						/>
						<Form.Check
							onChange={e=>{
								setCreateWorkouts(e.target.checked)
							}}
							checked={createWorkouts}
							id="create-semi-private-workouts-check"
							label="Add sessions as a workout to client calendars."
						/>
						<small>
							<OverlayTrigger overlay={
								<Tooltip>
									For example, setting this to 5 will prevent a client from being able to cancel or sign up 5 hours before the session
								</Tooltip>
							}>
								<i className="fa fa-info-circle mr-1"/>
							</OverlayTrigger>
							Signup/Cancel Limit
						</small>
						<Form.Control 
							type="number"
							onChange={e=>{
								setSignupCancelBuffer(e.target.value)
							}}
							value={signupCancelBuffer}
							placeholder="number of hours before"
						/>
					</div>
				}
				{trainingType==='group_session'&&
					<div>
						<small>Class Size</small>
						<Form.Control 
							value={classSize}
							onChange={e=>{
								setClassSize(e.target.value)
							}}
						/>
						<Form.Check
							onChange={e=>{
								setCreateWorkouts(e.target.checked)
							}}
							checked={createWorkouts}
							id="create-class-workouts-check"
							label="Add class as a workout to client calendars."
						/>
						<Form.Check
							onChange={e=>{
								setDeductSesions(e.target.checked)
							}}
							checked={deductSessions}
							id="deduct-session-credit-check"
							label="Deduct session credit when client registers"
						/>
					</div>
				}
				{(createWorkouts&&noEndDate)&&
                    <small className="text-danger"> 
                        <i className="fa fa-info-circle mr-1"/>
                        If you don't specify an end date you can only sync 100 workouts at a time. You can re-sync 100 more in the future when needed.
                    </small>
                }
				{trainingType==='training'&&
					<div>
						<Form.Check
							onChange={e=>{
								setDeductSesions(e.target.checked)
							}}
							checked={deductSessions&&!noEndDate}
							id="deduct-session-credit-check"
							label={`Deduct session credits`}
						/>
					</div>
				}
				<div className="d-flex">
					<div className={repeat==='none'?'w-100':'w-50'}>
						<small>Recurring</small>
						<Form.Control 
							onChange={e=>{
								setRepeat(e.target.value)
							}}
							value={repeat}
							as="select" 
						>
							<option value="none">
								No Repeat
							</option>
							<option value="day">
								Daily
							</option>
							<option value="week">
								Weekly
							</option>
						</Form.Control>
					</div>
					{repeat==='day'&&
						<div className="w-50 ml-1">
							<small>Repeat Frequency</small>
							<Form.Control 
								onChange={e=>{
									setDailyInterval(e.target.value)
								}} 
								value={dailyInterval} 
								as="select"
							>
								{nMap(10,(i)=>(
									<option value={i+1}>
										{
											i===0
											? 'Every day'
											: `Every ${i+1} days`
										}
									</option>
								))}
								<option value="custom">
									Custom
								</option>
							</Form.Control>
						</div>
					}
					{repeat==='week'&&
						<div className="w-50 ml-1">
							<small>Repeat Frequency</small>
							<Form.Control 
								placeholder="weeks"
								onChange={e=>{
									setWeeklyInterval(e.target.value)
								}} 
								value={weeklyInterval} 
							/>
						</div>
					}
				</div>
				{repeat==='week'&&
					<div>
						<small>Days of the week</small>
						<div className="d-flex flex-wrap">
							{daysOfTheWeek.map(
								weekDay => (
									<Form.Check 
										size="sm"
										onChange={e=>{
											setWeekDays(
												p => (
													e.target.checked
													? [...p,weekDay]
													: p.filter(d=>d!==weekDay)
												)
											)
										}}
										checked={weekDays.includes(weekDay)}
										className="mr-2 mb-2"
										id={`create-weekday-check-${weekDay}`}
										label={weekDayDisplayNameMap[weekDay]}
									/>
								)
							)}
						</div>
					</div>
				}
				{(repeat==='day'&&dailyInterval==='custom')&&
					<div>
						<small>Custom Repeat Frequency</small>
						<Form.Control
							onChange={e=>{
								setCustomDailyInterval(e.target.value)
							}}
							value={customDailyInterval}
						/>
					</div>
				}
				<div className="d-flex my-1 justify-content-between flex-wrap">
					<div>
						<small>{repeat==='none'?'Date':'Start Date'}</small>
						<InputGroup>
							<InputGroup.Prepend>
								<InputGroup.Text>
									<i className="fa fa-calendar"/>
								</InputGroup.Text>
							</InputGroup.Prepend>
							<DatePicker 
								onChange={date=>{
									setStartDate(date)
								}}
								selected={startDate}
								customInput={<Form.Control style={{borderRadius:'0 5px 5px 0'}}/>}
							/>
						</InputGroup>
						{repeat!=='none'&&
							<Form.Check
								className="mt-1"
								onChange={e=>{
									setNoEndDate(e.target.checked)
								}}
								checked={noEndDate}
								id="create-no-end-date-check"
								label="No end date"
							/>
						}
					</div>
					{(repeat!=='none'&&!noEndDate)&&
						<div>
							<small>End Date</small>
							<InputGroup>
								<InputGroup.Prepend>
									<InputGroup.Text>
										<i className="fa fa-calendar"/>
									</InputGroup.Text>
								</InputGroup.Prepend>
								<DatePicker 
									onChange={date=>{
										setEndDate(date)
									}}
									selected={endDate}
									customInput={<Form.Control style={{borderRadius:'0 5px 5px 0'}}/>}
								/>
							</InputGroup>
						</div>
					}
					<div className="text-center w-100">
						<ReadableRepeat 
							repeatType={repeat}
							eventType={trainingType} 
							startDate={startDate}
							endDate={endDate} 
							interval={
								repeat === 'week'
								? weeklyInterval
								: (
									dailyInterval === 'custom'
									? customDailyInterval
									: dailyInterval
								)
							} 
							weekDays={weekDays}
							weekRepeatFreq={
								weeklyInterval
							}
							noEndDate={noEndDate}
						/>
					</div>
					<div>
						<small>Time</small>
						<div className="d-flex align-items-center">
							<TimePicker
								onChange={newTimeObj=>{
									setStartTime(newTimeObj)
								}}
								minuteInterval={15}
								hour={startTime.hour}
								minute={startTime.min}
								period={startTime.p}
								isTime24Hour={isTime24Hour}
							/>
							<span>-</span>
							<TimePicker
								onChange={newTimeObj=>{
									setEndTime(newTimeObj)
								}}
								minuteInterval={15}
								hour={endTime.hour}
								minute={endTime.min}
								period={endTime.p}
								isTime24Hour={isTime24Hour}
							/>
						</div>
					</div>
				</div>
				{!['closed','notes','semi_private'].includes(trainingType)&&
					<div>
						<small>Trainers</small>
						<Select
							selected={selectedTrainers}
							onChange={setSelectedTrainers}
							options={trainerOptions}
							isMulti
						/>
					</div>
				}
				{!['meeting','personal','closed','notes'].includes(trainingType)&&
					<div>
						<small>Clients</small>
						<Select
							onChange={setSelectedClients}
							selected={selectedClients}
							options={clientOptions}
							isMulti
						/>
					</div>
				}
				{trainingType!=='personal'&&
					<div>
						<small>Reminders</small>
						<Form.Control 
							onChange={e=>{
								setReminderTime(e.target.value)
							}}
							value={reminderTime} 
							as="select"
						>
							<option value="none">None</option>
							{reminderOptions.map(h=>(
								<option value={h}>
									{h} hours before event
								</option>
							))}
						</Form.Control>
						{reminderTime!=='none'&&
							<div>
								<Form.Check
									onChange={e=>{
										setPushReminders(e.target.checked)
									}}
									checked={pushReminders}
									id="create-push-note-check"
									label="Push Notifications"
								/>
								<Form.Check
									onChange={e=>{
										setEmailReminders(e.target.checked)
									}}
									checked={emailReminders}
									id="create-email-check"
									label="Email Notifications"
								/>
							</div>
						}
					</div>
				}
				<div>
					<small>After creating on FitSW, you can sync with other calendars</small>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<div>
					<Button disabled={isSaving} onClick={onHide} variant="outline-danger" className="mr-1">
						Close
					</Button>
					<Button 
						disabled={isSaving||(!Boolean(selectedTrainers.length)&&!['meeting','closed','notes','semi_private'].includes(trainingType))} 
						onClick={handleSave} 
						variant="outline-success"
					>
						Save {isSaving&&<Spinner animation="border" size="sm"/>}
					</Button>
					{(!Boolean(selectedTrainers.length)&&!['meeting','closed','notes','semi_private'].includes(trainingType))&&
						<small className="d-block">Please select a trainer</small>
					}
				</div>
			</Modal.Footer>
		</Modal>
	)
}